module.exports = __webpack_public_path__ + "static/young-944f799ae8397d101fcfc5ca911fab7b.jpg";